import React, { PropsWithChildren } from 'react';
import { Box, Container, Stack, Link as MuiLink, Grid, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const StaticPageLayout: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Box component="header" sx={{ 
        backgroundColor: 'primary.main', 
        color: 'white',
        position: 'sticky',
        top: 0,
        zIndex: 1100
      }}>
        <Container maxWidth="lg">
          <Stack direction="row" spacing={3} py={2} alignItems="center">
            <MuiLink component={RouterLink} to="/" sx={{ display: 'flex', alignItems: 'center' }}>
              <img src="/logo.svg" alt="ET-Business Logo" style={{ height: 40 }} />
            </MuiLink>
            <Stack direction="row" spacing={3} sx={{ ml: 'auto' }}>
              <MuiLink component={RouterLink} to="/" color="inherit" sx={{ '&:hover': { color: 'secondary.light' } }}>
                Home
              </MuiLink>
              <MuiLink component={RouterLink} to="/business-categories" color="inherit" sx={{ '&:hover': { color: 'secondary.light' } }}>
                Business Categories
              </MuiLink>
              <MuiLink component={RouterLink} to="/cities" color="inherit" sx={{ '&:hover': { color: 'secondary.light' } }}>
                Cities
              </MuiLink>
              <MuiLink component={RouterLink} to="/about" color="inherit" sx={{ '&:hover': { color: 'secondary.light' } }}>
                About
              </MuiLink>
              <MuiLink component={RouterLink} to="/contact" color="inherit" sx={{ '&:hover': { color: 'secondary.light' } }}>
                Contact
              </MuiLink>
            </Stack>
          </Stack>
        </Container>
      </Box>

      <Box component="main" sx={{ flex: 1 }}>
        {children}
      </Box>

      <Box component="footer" sx={{ backgroundColor: 'grey.100', py: 4 }}>
        <Container maxWidth="lg">
          <Grid container spacing={4}>
            <Grid item xs={12} sm={4}>
              <Typography variant="h6" gutterBottom>Quick Links</Typography>
              <Stack spacing={1}>
                <MuiLink component={RouterLink} to="/" color="inherit">Home</MuiLink>
                <MuiLink component={RouterLink} to="/business-categories" color="inherit">Business Categories</MuiLink>
                <MuiLink component={RouterLink} to="/cities" color="inherit">Cities</MuiLink>
                <MuiLink component={RouterLink} to="/about" color="inherit">About</MuiLink>
                <MuiLink component={RouterLink} to="/contact" color="inherit">Contact</MuiLink>
              </Stack>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Typography variant="h6" gutterBottom>Legal</Typography>
              <Stack spacing={1}>
                <MuiLink component={RouterLink} to="/privacy-policy" color="inherit">Privacy Policy</MuiLink>
                <MuiLink component={RouterLink} to="/terms-of-service" color="inherit">Terms of Service</MuiLink>
              </Stack>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Typography variant="h6" gutterBottom>Contact Us</Typography>
              <Stack spacing={1}>
                <Typography variant="body2">Email: info@et-business.com</Typography>
                <Typography variant="body2">Phone: +251 123 456 789</Typography>
                <Typography variant="body2">Bole Road, Addis Ababa, Ethiopia</Typography>
              </Stack>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Box>
  );
};

export default StaticPageLayout; 